import nextApi from "./next-api";

const getCollegeImages = (id) => {
  return nextApi.get(`cms/college-images?id=${id}`);
};

const createCollegeImages = (data, id) => {
  return nextApi.post(`cms/college-images?id=${id}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const updateCollegeImages = (data, id) => {
  return nextApi.put(`cms/college-images?id=${id}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const deleteCollegeImages = (imageId) => {
  return nextApi.delete(`cms/college-images?uploadId=${imageId}`);
};

const CollegeImagesService = {
  getCollegeImages,
  createCollegeImages,
  updateCollegeImages,
  deleteCollegeImages,
};

export default CollegeImagesService;
